// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Sn-z","badgeLink":"Tn-z","category":"Un-z"};